import {InvoiceItemSchema, InvoiceItemTypeList, InvoiceItemTypes} from "./Api/Invoice";
import {VatTariffs} from "./VatService";

class VehicleInvoiceItemFactory
{
    static newFrom(instance, netPrice = 0) {
        return new InvoiceItemSchema({
            type: InvoiceItemTypes.TYPE_VEHICLE,
            type_text: InvoiceItemTypeList.find(
                item => item.value === InvoiceItemTypes.TYPE_VEHICLE
            ).label,
            instance_id: instance.id,
            instance: instance,
            description: `${instance.vehicle.registration.formatted_vrm} - ${instance.vehicle.file_as} (${instance.vehicle.vin}) - ${instance.vehicle.mileage} miles`,
            unit_net: netPrice,
            unit_cost: netPrice,
            vat_rate: instance.is_vat_qualifier ? VatTariffs.STANDARD : VatTariffs.NONE
        })
    }
}

export {
    VehicleInvoiceItemFactory
}